export const permissionsStore = {
    state: {
      userPermissions: [] 
    },
    mutations: {
      setUserPermissions(state, permissions) {
        state.userPermissions = permissions;
      },
    },
  }
  